/** Add Route Component */
import Home from "../pages/home";
import PrivacyPolicy from "../pages/privacypolicy";
import TermsOfService from "../pages/termsofservice";
import DetailJob from "../pages/detailjob";
import Login from "../pages/cms/Login";
import Dashboard from "../pages/cms/Dashboard";
import JobEditor from "../pages/cms/JobEditor";

interface RouteProps {
  path: string;
  component?: any;
  exact?: boolean;
  isDark: boolean;
}

const routes: Array<RouteProps> = [{ path: "/", component: <Home />, isDark: true }];
const publicroute = [
  { path: "/privacypolicy", component: <PrivacyPolicy /> },
  { path: "/termsofservice", component: <TermsOfService /> },
  { path: "/detailjob/:jobName", component: <DetailJob /> },
  { path: "/cms/login", component: <Login /> },
];

const cmsProtectedRoutes: any[] = [
  { path: "/cms", component: <Dashboard /> },
  { path: "/cms/new", component: <JobEditor /> },
  { path: "/cms/edit/:slug", component: <JobEditor /> }
];

export { publicroute, routes, cmsProtectedRoutes };
